import React from 'react';
import SideMenu from "../../components/SideMenu/SideMenu"
import HomeContent from "./HomeContent"
import styles from './Home.module.scss';
import { useEffect } from 'react';

function Home(props) {
  useEffect(() => {
    document.title = 'Home';
  }, []);
  return (
    <div className={styles.root}>
      <SideMenu />
      <HomeContent />
    </div>
  );
}

export default Home;